import { render, staticRenderFns } from "./jdMovieOrderDetail.vue?vue&type=template&id=07a9652a&scoped=true&"
import script from "./jdMovieOrderDetail.vue?vue&type=script&lang=js&"
export * from "./jdMovieOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./jdMovieOrderDetail.vue?vue&type=style&index=0&id=07a9652a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a9652a",
  null
  
)

export default component.exports